module.exports = __webpack_public_path__ + "static/media/light-01.b3fe59dd.jpg";